<script>
import Base from '@backend/Base.vue';
import Gen from '@helper/Gen.js';
import BOGen from '@helper/BOGen.js';
const swal2 = require('sweetalert2')

export default {
  extends: Base,
  data(){
    return {
      Name:"ImportEmployee",
      PageName: "Import Employee",
      ObjectName: "Import Employee",
      // input: {employee_update:"employee/EmployeeUpdate.xlsx"},
      input: { type: 'add', use_onboarding_checklist: true },
      WithLimit: true,
      errors: [],
      mrRequest: [
        {'ty_id': 'add', 'ty_name': 'Add Employee'},
        {'ty_id': 'replace', 'ty_name': 'Replace Employee'}
      ],
      row: {},
      filter: {},
      detailData: {}
    }
  },
  mounted(){
    this.$set(this.$root, 'page', this)
    this.refreshData()
  },
  methods:{
    submitForm(){
      this.errors = []
      BOGen.apirest("/ImportEmployee", this.input, (err, resp)=>{
        if(err) return this.errors = err.json.message;
        swal2.fire({
          title: 'Importing Data ...',
          timer: 2000,
          timerProgressBar: true,
          didOpen: () => {
            swal2.showLoading()
          },
        }).then((result) => {
          global.swal("Success", "Import employee data successful.", "success").then(()=>{
            location.reload()
          })
        })
      }, "POST")
    },

    showChoosenChecklist(){
      swal2.fire({
        title: "Does the data require an onboarding checklist?",
        html: `
          Whether the data that has been uploaded requires an onboarding checklist if not click the <strong>'No Need'</strong> button 
          and if it requires it click the <strong>'Need'</strong> button.
        `,
        icon: "warning",
        showCloseButton: true,
        showCancelButton: true,
        confirmButtonText: `
          Need
        `,
        cancelButtonText: `
          No Need
        `,
        allowOutsideClick: false,
        allowEscapeKey: false,
        allowEnterKey: false,
        showCloseButton: false,
        // dangerMode: true,
      }).then(click => {
        this.$set(this.input, 'use_onboarding_checklist', click.isConfirmed)
      })
    }
  },
  watch:{
    '$route.query'(){ this.refreshData(); if(this.$route.params.id) this.row = {} },
    'input.employee_update'(v){
      // Hanya superadmin aja yang akan dimunculin popup ini
      if(this.user.access_level === 1 && v) this.showChoosenChecklist()
    }
  }
}
</script>

<template>
  <div class="container-fluid mt-3">
    <template v-if="!$route.params.id">
      <VForm @resp="submitForm" method="post">
        <div class="card">
          <div class="card-body card-form">
            <h4 class="card-title">{{ObjectName}} Form</h4>
          </div>
          <div class="card-body">
            <div class="row">
              <div class="col-md-3 col-sm-4">
                <BoField label="Template">
                  <a :href="uploader('template/EmployeeUpdate.xlsx')" class="btn btn-success upload-btn">
                    <i class="ti-download"></i> Download Template
                  </a>
                </BoField>
              </div>
              <div class="col-md-9 col-sm-8">
                <BoField name="employee_update" mandatory label="Employee Data Document">
                  <Uploader :isDisable="!input.type ? true : false" name="employee_update" path="employee" v-model="input.employee_update" @response="()=>{ errors = [] }" accept="excel" :uniq="true" :attr="{required:true}"></Uploader>
                </BoField>
              </div>

              <div class="col-sm-12">
                <div class="alert alert-danger" v-if="errors.length">
                  <ul class="pl-2 mb-1">
                    <li v-for="(v,k) in errors" :key="k" v-html="v"></li>
                  </ul>
                </div>
              </div>

              <div class="col-sm-12">
                <div class="text-right">
                  <button type="submit" class="fcbtn btn btn-info btn-outline btn-1e btn-loading">
                    Import Employee Data
                    <i class="icon-arrow-right14 position-right"></i>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </VForm>
      <div class="card">
        <div class="card-body">
          <VForm @resp="search">
            <div class="row">
              <div class="col-sm-3">
                <h4 class="card-title">{{ObjectName}} List <span v-if="data.total">({{(data.total||0).format()}})</span></h4>
              </div>
              <div class="col-sm-3"></div>
              <div class="col-sm-2">
                <Select2 :options="BoConfig.mrPageLimit" v-model="filter.limit" @input="changeLimit"></Select2>
              </div>
              <div class="col-sm-3">
                <div class="has-feedback has-feedback-left">
                  <input type="search" v-model="filter.search" @keyup.enter="search" class="form-control" placeholder="Type and hit Enter">
                  <div class="form-control-feedback">
                    <i class="icon-search4 text-size-base text-muted"></i>
                  </div>
                </div>
              </div>
              <div class="col-sm-1">
                <button type="button" @click="resetSearch()" class="btn btn-warning btn-sm">Reset</button>
              </div>
            </div>
          </VForm>
        </div>
        <div class="table-responsive ajax-table">
          <table class="table table-striped table-hover table-bordered mb-0">
            <thead>
              <tr>
                <th width="50px">#</th>
                <th><SortField name="employeename" :label="fields.employeename"></SortField></th>
                <th><SortField name="msg_name" :label="fields.mcc_msg_id"></SortField></th>
                <th>{{fields.mcc_costcenter}}</th>
                <th>{{fields.employee_status}}</th>
                <th width="120px">Action</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(v,k) in data.data" :key="k">
                <td class="number">{{(data.per_page*(data.current_page-1))+k+1}}</td>
                <td>
                  <div v-if="v.cwid">{{ v.cwid +' - '+v.employeename }}</div>
                  <div v-else>{{ v.employeename }}</div>
                  <small>{{ v.position || '-'}}</small>
                </td>
                <td>{{v.msg_name || '-'}}</td>
                <td>{{v.costcenter || '-'}}</td>
                <td><StatusLabel :status="v.status ? true : false"></StatusLabel></td>
                <td class="btn-action">
                  <router-link :to="{ name: 'ImportEmployee', params: { id: v.id } }" v-tooltip="'View Details'" class="icon_action"><i class="icon-eye"></i></router-link>
                </td>
              </tr>
              <tr v-if="NotFound">
                <td colspan="99">
                  <h3 class="tc">{{NotFound}}</h3>
                </td>
              </tr>
              <tr v-if="data.data===false">
                <td colspan="99">
                  <LoadingSpinner light></LoadingSpinner>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="card-body">
          <div class="pull-right">
            <Pagination :data="data" :limit="3" @pagination-change-page="onPaging"></Pagination>
          </div>
        </div>
      </div>
    </template>
    <div class="card" v-else>
      <div class="card-body">
        <router-link class="btn btn-outline-info btn-sm mb-3" :to="{ name: 'ImportEmployee' }">
          <i class="icon-arrow-left mr-1"></i>
          Back to Employee List
        </router-link>
        <div class="row">
          <div class="col-md-9">
            <div class="row row-gutter">
              
              <div class="col-md-3">
                <div class="detail-info">
                  <strong>CWID</strong>
                  <span>{{ row.cwid || "-"}}</span>
                </div>
              </div>
              
              <div class="col-md-3">
                <div class="detail-info">
                  <strong>Full Name</strong>
                  <span>{{ row.employeename || "-"}}</span>
                </div>
              </div>

              <div class="col-md-3">
                <div class="detail-info">
                  <strong>Department</strong>
                  <span>{{ row.department }}</span>
                </div>
              </div>

              <div class="col-md-3">
                <div class="detail-info">
                  <strong>IPIN</strong>
                  <span>{{ row.IPIN || "-"}}</span>
                </div>
              </div>
              
              <div class="col-md-3">
                <div class="detail-info">
                  <strong>Email</strong>
                  <span>{{ row.email || "-" }}</span>
                </div>
              </div>

              <div class="col-md-3">
                <div class="detail-info">
                  <strong>Admin Manager CWID</strong>
                  <span>{{ row.manager || "-"}}</span>
                </div>
              </div>

              <div class="col-md-3">
                <div class="detail-info">
                  <strong>Employee Category</strong>
                  <span>{{ row.mws_name || "-" }}</span>
                </div>
              </div>
              <div class="col-md-3">
                <div class="detail-info">
                  <strong>Employee Cost Center</strong>
                  <span>{{ row.costcenter }}</span>
                </div>
              </div>

              <div class="col-md-3">
                <div class="detail-info">
                  <strong>Position Title</strong>
                  <span>{{ row.position || "-"}}</span>
                </div>
              </div>

              <div class="col-md-3">
                <div class="detail-info">
                  <strong>Employee Status</strong>
                  <status-label :status="row.status ? true : false" />
                </div>
              </div>

              <div class="col-md-3">
                <div class="detail-info">
                  <strong>Effective Join Date</strong>
                  <span v-if="row.effective_join_date">{{ moment(row.effective_join_date).format('DD MMM YYYY') }}</span>
                  <span v-else>-</span>
                </div>
              </div>

            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
